export default "__VITE_ASSET__6f32a760__$_?nuxt_component=async__"